// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';

// Layouts
import LayoutApp from '@layouts/LayoutApp';

export default {
    path: '/',
    component: LayoutApp,
    children: [
        {
            path: 'agency',
            component: () => import('@pages/agency/PageAgencyCreate'),
            redirect: { name: 'agency.create' },
        },
        {
            path: 'agencies',
            name: 'agency.create',
            component: () => import('@pages/agency/PageAgencyCreate'),
            meta: {
                middleware: AuthMiddleware,
                title: 'Create Agency',
            },
        },
        {
            path: 'agencies/:id',
            name: 'agency',
            component: () => import('@pages/agency'),
            redirect: { name: 'agency.settings' },
            children: [
                {
                    path: 'settings',
                    name: 'agency.settings',
                    component: () => import('@pages/agency/PageAgencySettings'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.settings'],
                    },
                },
                {
                    path: 'domain',
                    name: 'agency.domain',
                    component: () => import('@pages/agency/PageAgencyDomain'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.domain'],
                    },
                },
                {
                    path: 'appearance',
                    name: 'agency.appearance',
                    component: () => import('@pages/agency/PageAgencyAppearance'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.appearance'],
                    },
                },
                {
                    path: 'projects',
                    name: 'agency.projects',
                    component: () => import('@pages/agency/PageAgencyProjects'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.projects'],
                    },
                },
                {
                    path: 'links',
                    name: 'agency.links',
                    component: () => import('@pages/agency/PageAgencyLinks'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.external_links'],
                    },
                },
                {
                    path: 'clients',
                    name: 'agency.clients',
                    component: () => import('@pages/agency/PageAgencyClients'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.clients'],
                    },
                },
                {
                    path: 'team',
                    name: 'agency.team',
                    component: () => import('@pages/agency/PageAgencyTeam'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.team'],
                    },
                },
                {
                    path: 'email',
                    name: 'agency.email',
                    component: () => import('@pages/agency/PageAgencyTemplates'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.email'],
                    },
                },
                {
                    path: 'editor',
                    name: 'agency.editor',
                    component: () => import('@pages/agency/PageAgencyEditor'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.code_editor'],
                    },
                },
                {
                    path: 'api',
                    name: 'agency.api',
                    component: () => import('@pages/agency/PageAgencyApi'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.api'],
                    },
                },
                {
                    path: 'mcp',
                    name: 'agency.mcp',
                    component: () => import('@pages/agency/PageAgencyMcp'),
                    meta: {
                        middleware: AuthMiddleware,
                        title: ['titles.agency', 'labels.mcp_server'],
                    },
                },
            ],
        },
    ],
};